import { HardwareType } from "@formant/core/model/HardwareType";

export function cleanHardwareName(name: string, type?: HardwareType) {
    const partRegex = /[^A-Za-z0-9-_. ]/g;
    if (type === "ip") {
        if (name.indexOf("@") > 0) {
            name = "rtsp." + name.substring(name.indexOf("@") + 1);
        }
        name = name.replace("://", ".");

        name = name.replace("/", ".").replace(":", ".");
        name = name.replace(partRegex, "");
        name = name.replace("..", ".");
        return name;
    } else if (!type || type === "usb") {
        name = name.replace("/dev/video", "dev.video");
        return name.replace(partRegex, "");
    }
    return name;
}
